module.exports = __webpack_public_path__ + "static/media/nihongjie.edc4a4fe.png";